export default __webpack_public_path__ + "static/media/Car_Insurance.c595f77b.svg";